
// let reg =''.replace(/(.*\/)*([^.]+).*/ig,"$1") //匹配文件名之前的地址（变向拿文件名）

// 遮罩层
const Mask = (function(){
    let tag = null
    return class {
        constructor(){
            if(tag){
                return tag
            }else{
                tag = this
            }
            this.body = document.getElementsByTagName('body')[0]
            this.mask = document.createElement('div')
            this.mask.style.cssText = 'position:fixed;left:0;right:0;top:0;bottom:0;z-index:990;background-color:rgba(0,0,0,.6)'
            this.o_close = document.createElement('span')
            this.o_close.innerText = 'X'
            this.o_close.style.cssText = 'position:absolute;right:20px;top:20px;width:40px;height:40px;line-height:40px;text-align:center;font-size:22px;color:#444;border-radius:50%;background-color:#fff;cursor:pointer;'
            this.mask.appendChild(this.o_close)
        }
    }
})()

// 图片放大
class Pictures extends Mask{
    constructor(url){
        super(url)
        this.img = document.createElement('img')
        this.img.src = url
        this.img.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;max-width:800px;max-height:800px;'
        this.mask.appendChild(this.img)
        this.body.appendChild(this.mask)
        this.o_close.onclick = this.close.bind(this)
    }
    close(){
        this.mask.removeChild(this.img)
        this.body.removeChild(this.mask)
    }
}

export {
    Mask,
    Pictures
}